<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-10">
      <!-- begin col-4 -->
      <div class="col-xl-6 col-lg-6">
        <!-- begin card -->
        <div
          class="card border-0 mb-3"
          :class="{ 'bg-dark-darker text-white': inverseMode }"
        >
          <!-- begin card-body -->
          <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
              <b>NEARLY EXPIRED PRODUCT</b>
              <span class="text-grey ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Nearly Expired Product"
                  v-b-popover.hover="
                    'Total online store sales that came from a social referrer source.'
                  "
                ></i
              ></span>
            </div>
            <!-- end title -->
          </div>
          <!-- end card-body -->
          <!-- begin widget-list -->
          <div
            class="widget-list widget-list-rounded"
            :class="{ 'inverse-mode': inverseMode }"
          >
            <!-- begin widget-table -->
            <div class="table-responsive ts-h-40">
              <!-- begin widget-table -->
              <table
                class="table table-bordered widget-table widget-table-rounded"
                v-bind:class="{ 'inverse-mode': inverseMode }"
              >
                <thead>
                  <tr>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300" width="1%">
                      Image
                    </th>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">Bacode</th>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">
                      Product Name
                    </th>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">UOM</th>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">Qty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record, index) in nearlyExpiredResources"
                    :key="index"
                  >
                    <td>
                      <img
                        v-lazy="{
                          src: record.photo ? record.photo : null,
                          error: require('@/assets/default-product.jpg'),
                          loading: require('@/assets/Rolling-1s-200px_2.svg')
                        }"
                      />
                    </td>
                    <td>
                      {{ record.barcode }}
                    </td>
                    <td>
                      <h4 class="widget-table-title">
                        {{ record.product_name }}
                      </h4>
                    </td>
                    <td>{{ record.uom_name }}</td>
                    <td>{{ record.quantity }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- end widget-table -->
            </div>
            <!-- end table-responsive -->
          </div>
          <!-- end widget-list -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-4 -->
      <!-- begin col-4 -->
      <div class="col-xl-6 col-lg-6">
        <!-- begin card -->
        <div
          class="card border-0 mb-3"
          :class="{ 'bg-dark-darker text-white': inverseMode }"
        >
          <!-- begin card-body -->
          <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
              <b>RE-ORDER PRODUCT</b>
              <span class="text-grey ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Re-order product"
                  v-b-popover.hover="
                    'Total online store sales that came from a social referrer source.'
                  "
                ></i
              ></span>
            </div>
            <!-- end title -->
          </div>
          <!-- end card-body -->
          <!-- begin widget-list -->
          <div
            class="widget-list widget-list-rounded"
            :class="{ 'inverse-mode': inverseMode }"
          >
            <!-- begin widget-table -->
            <div class="table-responsive ts-h-40">
              <!-- begin widget-table -->
              <table
                class="table table-bordered widget-table widget-table-rounded"
                v-bind:class="{ 'inverse-mode': inverseMode }"
              >
                <thead>
                  <tr>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">Bacode</th>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">
                      Product Name
                    </th>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">QTY</th>
                    <th class="ts-sticky ts-top-0 ts-bg-gray-300">
                      Re-order QTY
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record, index) in reOrderProductResources"
                    :key="index"
                  >
                    <td>
                      {{ record.barcode }}
                    </td>
                    <td>
                      <h4 class="widget-table-title">
                        {{ record.product_name }}
                      </h4>
                    </td>
                    <td>{{ record.quanitty }}</td>
                    <td>{{ record.reorder_qty }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- end widget-table -->
            </div>
            <!-- end table-responsive -->
          </div>
          <!-- end widget-list -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-4 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  props: ['inverseMode'],
  data () {
    return {
      loading: false,
      nearlyExpiredResources: null,
      reOrderProductResources: null
    }
  },
  filters: {
    format_number (value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  },
  methods: {
    ...mapActions('dashboard/widget', [
      'fetchNearlyExpired',
      'fetchReOrderProduct'
    ]),
    moment,
    async fetchData () {
      this.loading = true
      await this.fetchNearlyExpired()
        .then(responses => {
          this.nearlyExpiredResources = responses
        })
        .catch(() => {
          // this.$toasted.error(error.message)
          this.loading = false
        })
      this.fetchReOrderProduct()
        .then(responses => {
          this.reOrderProductResources = responses
          this.loading = false
        })
        .catch(() => {
          // this.$toasted.error(error.message)
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.bg-dark-darker {
  background-color: #22282d !important;
}
</style>
